export function removeBodyScrollbar(condition: boolean) {
  if (condition) {
    var root = document.getElementsByTagName('html')[0];
    document.body.classList.add('no-scroll');
    root.classList.add('no-scroll');
  } else {
    var root = document.getElementsByTagName('html')[0];
    document.body.classList.remove('no-scroll');
    root.classList.remove('no-scroll');
  }
}

export function setStorageBooking(
  booking: {slug: string; bookingId: string},
) {
 
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('booking', JSON.stringify(booking));
  }
}

export function deleteStorageBooking(){
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem("booking")
  }
}

export function getStorageBooking() {
  let savedBooking: {slug?: string; bookingId?: string} = {};

  if (typeof window !== 'undefined') {
    try {
      const bookingItem = window.localStorage.getItem('booking');
      const booking: {slug: string; bookingId: string} = bookingItem
        ? JSON.parse(bookingItem)
        : {};
      savedBooking = booking;
    } catch (error) {
      if (error instanceof Error) {
        console.log(`JSPERROR:109:${error.message}`);
      } else {
        console.log("JSPERROR:109", error);
      }
    }
  }

  return savedBooking;
}
